import services_bulk from "../views/services_bulk/index.vue";
import services_bulk_create from "../views/services_bulk/create.vue";
import services_bulk_edit from "../views/services_bulk/edit.vue";
import services_bulk_detail from "../views/services_bulk/detail.vue";
import services_bulk_import from "../views/services_bulk/import.vue";

const routes = [
  {
    path: "/services_bulk",
    name: "services_bulk",
    component: services_bulk,
    meta: { authOnly: true }
  },
  {
    path: "/services_bulk/create",
    name: "services_bulk_create",
    component: services_bulk_create,
    meta: { authOnly: true }
  },
  {
    path: "/services_bulk/edit/:uuid",
    name: "services_bulk_edit",
    component: services_bulk_edit,
    meta: { authOnly: true }
  },
  {
    path: "/services_bulk/detail/:uuid",
    name: "services_bulk_detail",
    component: services_bulk_detail,
    meta: { authOnly: true }
  },
  {
    path: "/services_bulk/import",
    name: "services_bulk_import",
    component: services_bulk_import,
    meta: { authOnly: true }
  }
];

export default routes;
